export default __webpack_public_path__ + "static/media/GooglePlay.a32b2e52.svg";